module.exports = __webpack_public_path__ + "img/dbf578b.png";